import { dashboard } from "../../../telemetry/TraceLogging";
import { Trace } from "../../../telemetry/Trace";
import { v4 as uuid } from "uuid";
//
// widget-instance custom element aka web component
// This element is the parent of each widget
//
export class WidgetInstanceElement extends HTMLElement {
    constructor() {
        super();
        this._instance = null;
        this._initializeWidget = null;
        this._isInitialized = false;
        this._observedAttributes = new Set();
        this._attributeCallbacks = new Map();
        this._isAdaptiveCardRendered = false;
        this._observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type == "attributes" && mutation.attributeName) {
                    this.attributeChangedCallback(mutation.attributeName, mutation.oldValue, mutation.target["attributes"][mutation.attributeName].nodeValue);
                }
            });
        });
        this._observer.observe(this, {
            attributes: true, //configure it to listen to attribute changes
        });
    }
    connectedCallback() {
        // element inserted into DOM
        var _a, _b;
        Trace.logEvent(dashboard, "WebAppWidgetInstanceConnected", 0 /* verbose */, {
            widgetDefinitionId: (_a = this._instance) === null || _a === void 0 ? void 0 : _a.widgetDefinitionId,
            widgetInstanceId: (_b = this._instance) === null || _b === void 0 ? void 0 : _b.widgetId,
        });
        // initialize the widget if it hasn't been yet
        if (this.isConnected && !this._isInitialized && this._initializeWidget != null) {
            this._initializeWidget().then(() => (this._isInitialized = true));
        }
    }
    disconnectedCallback() {
        // element removed from DOM
        var _a, _b;
        Trace.logEvent(dashboard, "WebAppWidgetInstanceDisconnected", 0 /* verbose */, {
            widgetDefinitionId: (_a = this._instance) === null || _a === void 0 ? void 0 : _a.widgetDefinitionId,
            widgetInstanceId: (_b = this._instance) === null || _b === void 0 ? void 0 : _b.widgetId,
        });
    }
    addAttributeListener(attrName, callback) {
        let attrId = uuid();
        if (!this._observedAttributes.has(attrName)) {
            this._observedAttributes.add(attrName);
            let attributeCallbackMap = new Map();
            attributeCallbackMap.set(attrId, callback);
            this._attributeCallbacks.set(attrName, attributeCallbackMap);
        }
        else {
            this._attributeCallbacks[attrName].set(attrId, callback);
        }
        return attrId;
    }
    removeAttributeListener(attrName, attrId) {
        if (this._observedAttributes.has(attrName)) {
            let callbacks = this._attributeCallbacks.get(attrName);
            if (callbacks !== undefined && callbacks.has(attrId)) {
                if (callbacks.size == 1) {
                    this._attributeCallbacks.delete(attrName);
                    this._observedAttributes.delete(attrName);
                }
                else {
                    callbacks.delete(attrId);
                }
            }
        }
    }
    attributeChangedCallback(attrName, oldVal, newVal) {
        // observed attribute added, removed, updated, or replaced
        // Also called for initial values for attributes on the element markup
        if (this._observedAttributes.has(attrName)) {
            let callbacks = this._attributeCallbacks.get(attrName);
            if (callbacks !== undefined) {
                for (const [_, callback] of callbacks) {
                    callback(this, oldVal, newVal);
                }
            }
        }
    }
    get observedAttributes() {
        // the observed attributes
        return this._observedAttributes; // list of 'attributes' to observe
    }
    get instance() {
        return this._instance;
    }
    set instance(val) {
        this._instance = val;
    }
    get initializeFn() {
        return this._initializeWidget;
    }
    set initializeFn(val) {
        this._initializeWidget = val;
    }
    get isAdaptiveCardRendered() {
        return this._isAdaptiveCardRendered;
    }
    set isAdaptiveCardRendered(val) {
        this._isAdaptiveCardRendered = val;
    }
}
